<template>
  <header >
    <div class="content clear">
      <div class="heading">
        <h1>iFootage competition</h1>
        <p>Congratulations! If you've got this far it means that you're ready to submit your finished video! Please now go ahead and do so! Our competition team will check it out and confirm your entry within the next couple of days. Thank you once again for entering and goodluck!</p>
      </div>
      <SubmissionForm/>
    </div>
  </header>
</template>

<script>
import SubmissionForm from './../SubmissionForm'

export default {
  name: 'Header',
  components: {
    SubmissionForm
  },
  props: {
    type: String
  }
}
</script>
